import { FC, memo } from "react";
import styles from "./BlogCTABanner.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import CustomLink from "@Components/CustomLink";

interface BlogCTABannerProps {
  heading: string;
  paragraph: string;
  buttonText: string;
  redirectUrl: string;
}

const BlogCTABanner: FC<BlogCTABannerProps> = ({ heading, paragraph, buttonText, redirectUrl }) => (
  <CustomLink
    href={redirectUrl}
    target="_blank"
    rel="noopener noreferrer"
    isExternal
    className={styles.ctaBanner}
  >
    <div className={styles.bannerTextSection}>
      <h5 className={styles.bannerHeading}>{heading}</h5>
      <p className={styles.bannerParagraph}>{paragraph}</p>
    </div>
    <span className={styles.button}>{buttonText}</span>
  </CustomLink>
);

export default wrapperHOC(memo(BlogCTABanner), {
  componentName: "BlogCTABanner-Blog",
  showForChina: true,
});
